// Load Bootstrap JS
import bootstrap from 'bootstrap'

// Load Styles
import '../scss/main.scss';
import initEmailAddress from "./modules/init_email_address";
import initSlider from "./modules/init_slider";
import initFixedMenu from './modules/init_fixed_menu';
import initApplicationForm from './modules/init_application_form';
// Demo of using .env variables
// console.log(`Google Maps API Key: ${process.env.GOOGLE_MAPS_API_KEY}`);

window.addEventListener('load',()=>{
  initEmailAddress('.ks-email');
  initSlider();
  //initFixedMenu();
  initApplicationForm();
})
